import { forwardRef, type ReactNode, type SelectHTMLAttributes } from 'react'

import { cn } from '@/lib/utils/cn'

import styles from './CompactSelect.module.css'

export interface CompactSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string
  icon?: ReactNode
  children: ReactNode
  className?: string
}

export const CompactSelect = forwardRef<HTMLSelectElement, CompactSelectProps>(
  function CompactSelect({ label, icon, children, className, ...rest }, ref) {
    return (
      <div className={cn(styles.wrapper, className)}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <select {...rest} ref={ref} aria-label={label} className={styles.select}>
          {children}
        </select>
      </div>
    )
  },
)
